import { updateObject } from 'sinks'
import { currentVersion } from './current-version'
import { migrationFunctions } from './migrations'
import { definition } from './definition'

const nullIfEmpty = item => {
  if (Object.keys(item).length === 0) {
    return null
  }
  return item
}

// plucks out migrations functions to run
// taking in account both current and target versions
// and available migrations
export const getRelevantMigrations = (
  caseDataVersion,
  migrations,
  targetVersion
) =>
  Object.keys(migrations)
    .map(Number)
    .filter(migrationKeyAsNumber => {
      const caseVersion = caseDataVersion || 0
      return (
        migrationKeyAsNumber > caseVersion &&
        migrationKeyAsNumber <= targetVersion
      )
    })
    .sort()
    .map(keyAsNumber => migrations[keyAsNumber.toString()])

/**
 * @param {CaseData} caseData
 * @param {{
 *   [id: string]: (caseData: CaseData) => any
 * }} migrations
 * @param {number} [targetVersion]
 */
export const getMigrationChanges = (
  caseData,
  migrations = migrationFunctions,
  targetVersion = currentVersion
) => {
  const { version } = caseData
  if (targetVersion === version) {
    return null
  }
  const relevantFns = getRelevantMigrations(version, migrations, targetVersion)

  let interimCaseData = caseData
  const cumulativeChanges = {}
  for (const fn of relevantFns) {
    const changes = fn(interimCaseData)
    interimCaseData = updateObject(interimCaseData, changes)
    Object.assign(cumulativeChanges, changes)
  }
  cumulativeChanges.version = targetVersion
  return nullIfEmpty(cumulativeChanges)
}

export const migrateToLatest = caseObject => {
  const copy = JSON.parse(JSON.stringify(caseObject))
  const migrationUpdates = getMigrationChanges(copy)
  if (migrationUpdates) {
    return definition.update(copy, migrationUpdates)
  }
  return copy
}
